import { useQuery } from '@tanstack/react-query';
import * as Api from '../api';
import type { AnalyticsParams, IntegrityResponse } from '../types';

interface IProps {
  orgId?: string;
  params: AnalyticsParams;
  enabled?: boolean;
}

const useIntegrity = ({ orgId, params, enabled = true }: IProps) =>
  useQuery<IntegrityResponse>({
    queryKey: ['analytics', 'integrity', orgId, params],
    queryFn: async () => {
      const { data } = await Api.GetIntegrity(params);
      return data;
    },
    enabled: !!orgId && enabled,
    staleTime: 30_000,
  });

export default useIntegrity;
